import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../../../services/modal.service';
import { VirtualCashModelsDto } from '../../models/virtual-cash.models';

@Component({
  selector: 'app-toggle-group-block-virtrual-cash-dialog',
  templateUrl: './toggle-group-block-virtrual-cash-dialog.component.html',
  styleUrls: ['./toggle-group-block-virtrual-cash-dialog.component.scss'],
})
export class ToggleGroupBlockVirtualCashDialogComponent {
  @Input() virtualPosCount?: number;
  @Input() groupStatus?: string;
  @Output() blockEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() unlockEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.isModalOpen$.next(false);
  }

  toggleBlock() {
    this.groupStatus === 'blocked'
      ? this.unlockEvent.emit()
      : this.blockEvent.emit();

    this.modalService.closeModal();
  }
}
